/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExcedentBilletVanzoliniViewModel } from "../types/ExcedentBilletVanzoliniViewModel.ts";

export const excedentBilletVanzoliniViewModelSchema = z.object({
  serialPaymentId: z.optional(z.number().int()),
  ourNumber: z.optional(z.number().int()),
  sourceParcelId: z.optional(z.number().int()),
  sourceParcelNumber: z.optional(z.number().int()),
  courseName: z.string().nullish(),
  planName: z.string().nullish(),
  totalParcel: z.optional(z.number()),
  totalPaid: z.number().nullish(),
  paidDate: z.string().datetime().nullish(),
  expirationDate: z.optional(z.string().datetime()),
  isPaid: z.optional(z.boolean()),
  isIntegrated: z.optional(z.boolean()),
}) as unknown as ToZod<ExcedentBilletVanzoliniViewModel>;
